import { curry } from "ramda";
window.mobileSeatsDiscounts = curry(function ($form) {
  var promocodeDialog = window.tcDialog({
    templateId: "discountsDialog",
  });

  $form.on("click", function () {
    promocodeDialog({}).catch(function (err) {
      console.log("error", err);
    });
  });

  return {
    $: $form,
  };
});
